import React from 'react';
import styles from './Timer.module.css';

const Timer = (props) => {    
    const min = Math.floor(props.timer.sec / 60);
    const sec = props.timer.sec % 60;
    const time = min + ':' + (sec < 10 ? '0' + sec : sec);

    return (
        <div className={styles.timer}>
            {time}
        </div>
    );
}

export default Timer;